import React from 'react';
import {
  ROUTE_FAN_FEED_ROOT, ROUTE_FAN_FEED_TAGS_ROOT, ROUTE_FAN_FEED_TAGS_NEW, ROUTE_FAN_FEED_TAGS_EDIT,
  ROUTE_FAN_FEED_POSTS_ROOT, ROUTE_FAN_FEED_POSTS_EDIT, ROUTE_FAN_FEED_SLIDESHOW
 } from './constants'

import FanFeedRoot from './FanFeedRoot'
import FanFeedTagsList from './FanFeedTagsList'
import FanFeedPostList from './FanFeedPostList'
import FanFeedSlideshowList from './FanFeedSlideshowList'

const FanBoxNew = () => <br/>
const FanBoxMessageEdit = () => <br/>

export default {
  path: ROUTE_FAN_FEED_ROOT,
  component: FanFeedRoot,
  indexRoute: {
    onEnter: (nextState, replace) =>
      replace({pathname: ROUTE_FAN_FEED_POSTS_ROOT}),
  },
  childRoutes: [
    {
      path: ROUTE_FAN_FEED_TAGS_ROOT,
      component: FanFeedRoot,
      indexRoute: {
        component: FanFeedTagsList
      },
      childRoutes: [
        {
          path: ROUTE_FAN_FEED_TAGS_NEW,
          component: FanBoxNew
        },
        {
          path: ROUTE_FAN_FEED_TAGS_EDIT,
          component: FanBoxMessageEdit
        }
      ]
    },
    {
      path: ROUTE_FAN_FEED_POSTS_ROOT,
      component: FanFeedRoot,
      indexRoute: {
        component: FanFeedPostList
      },
      childRoutes: [
        // {
        //   path: ROUTE_FAN_FEED_SLIDESHOW,
        //   component: FanFeedSlideshowList
        // },
        {
          path: ROUTE_FAN_FEED_POSTS_EDIT,
          component: FanFeedPostList
        }
      ]
    },
    // {
    //   path: ROUTE_FAN_FEED_SLIDESHOW,
    //   component: FanFeedRoot,
    //   indexRoute: {
    //     component: FanFeedPostList
    //   },
    //   childRoutes: [
    //     {
    //       path: ROUTE_FAN_FEED_SLIDESHOW,
    //       component: FanFeedSlideshowList
    //     },
    //   ]
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/components/FanFeed/router.tsx